import PrepaidPlanSetup from './PrepaidPlanSetup';

export default PrepaidPlanSetup;
